import { __decorate } from "tslib";
import { AutoEncoder, BooleanDecoder, IntegerDecoder, MapDecoder, StringDecoder, field } from '@simonbackx/simple-encoding';
import { upgradePriceFrom2To4DecimalPlaces } from '../upgradePriceFrom2To4DecimalPlaces.js';
export class ChargeMembershipsTypeSummary extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.memberships = 0;
        this.members = 0;
        this.price = 0;
        this.organizations = 0;
    }
}
__decorate([
    field({ decoder: IntegerDecoder })
], ChargeMembershipsTypeSummary.prototype, "memberships", void 0);
__decorate([
    field({ decoder: IntegerDecoder })
], ChargeMembershipsTypeSummary.prototype, "members", void 0);
__decorate([
    field({ decoder: IntegerDecoder }),
    field({ ...upgradePriceFrom2To4DecimalPlaces })
], ChargeMembershipsTypeSummary.prototype, "price", void 0);
__decorate([
    field({ decoder: IntegerDecoder })
], ChargeMembershipsTypeSummary.prototype, "organizations", void 0);
export class ChargeMembershipsSummary extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.running = false;
        this.memberships = 0;
        this.members = 0;
        this.price = 0;
        this.organizations = 0;
        this.membershipsPerType = new Map();
        this.trials = ChargeMembershipsTypeSummary.create({});
    }
}
__decorate([
    field({ decoder: BooleanDecoder })
], ChargeMembershipsSummary.prototype, "running", void 0);
__decorate([
    field({ decoder: IntegerDecoder })
], ChargeMembershipsSummary.prototype, "memberships", void 0);
__decorate([
    field({ decoder: IntegerDecoder })
], ChargeMembershipsSummary.prototype, "members", void 0);
__decorate([
    field({ decoder: IntegerDecoder }),
    field({ ...upgradePriceFrom2To4DecimalPlaces })
], ChargeMembershipsSummary.prototype, "price", void 0);
__decorate([
    field({ decoder: IntegerDecoder })
], ChargeMembershipsSummary.prototype, "organizations", void 0);
__decorate([
    field({ decoder: new MapDecoder(StringDecoder, ChargeMembershipsTypeSummary) })
], ChargeMembershipsSummary.prototype, "membershipsPerType", void 0);
__decorate([
    field({ decoder: ChargeMembershipsTypeSummary, version: 355 })
], ChargeMembershipsSummary.prototype, "trials", void 0);
//# sourceMappingURL=ChargeMembershipsSummary.js.map